import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const tableColumns = (handleAction) => [
    { dataField: "title", text: "Name", sort: true },
    { dataField: "active_relative_to", text: "Action Relative To", sort: true },
    { dataField: "timings", text: "Timing", sort: true },
    { dataField: "days", text: "Days", headerStyle: { width: "100px" }, },
    { dataField: "assigned_to", text: "Assigned To", },
    {
        dataField: "status", text: "Status",
        formatter: (cell) => (
            <span className={`badge rounded-pill ${["Active", "Verified"].includes(cell) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                }`} style={{ fontSize: '11px', padding: '5px 10px' }}>
                {cell}
            </span>
        )
    },
    {
        dataField: "actions", text: "", headerClasses: "text-end px-4", classes: "text-end px-4", isDummyField: true,
        formatter: (_, row) => (
            <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm border">
                    <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => handleAction("View", row)}>
                        <i className="bx bx-show-alt me-2 text-primary"></i> View
                    </DropdownItem>
                    <DropdownItem onClick={() => handleAction("Edit", row)}>
                        <i className="bx bx-pencil me-2 text-success"></i> Edit
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger">
                        <i className="bx bx-trash me-2"></i> Delete
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        ),
    },
];